import { Exporter } from "../export/exporter";
import { Pipeline } from "../export/pipeline";
import { z } from "zod";
export const ExportJobDump = z.object({
    id: z.string(),
    createdAt: z.coerce.date(),
    finishedAt: z.coerce.date(),
    exportArtefacts: z.string(),
});
export const CodeIntegrationDump = z.object({
    exporters: Exporter.array(),
    pipelines: Pipeline.array(),
    exportJobs: ExportJobDump.array(),
});
